import request from '@/utils/request'

export function login(pv) {
	return request({
		url: '/login',
		method: 'post',
		data: {
			...pv
		}
	})
}

export function getGroup(pv) {
	return request({
		url: '/robot/group?tenantInfoId=' + pv.replaceAll("\"", ""),
		method: 'get'
	})
}

export function getAllEventList(pv) {
	return request({
		url: '/event/allEventList?tenantInfoId=' + pv.replaceAll("\"", ""),
		method: 'get'
	})
}

export function getRobotEventList(pv, tenId, eventResult, disshowFlg) {
	return request({
		url: '/event/robotEventList?groupingId=' + pv.replaceAll("\"", "") + '&tenantInfoId=' + tenId
			.replaceAll("\"", "") + '&eventResult=' + eventResult.replaceAll("\"", "") + '&disshowFlg=' + disshowFlg.replaceAll("\"", ""),
		method: 'get'
	})
}

export function getRobotEventInfo(pv) {
	return request({
		url: '/event/eventInfo?eventId=' + pv.replaceAll("\"", ""),
		method: 'get'
	})
}

export function getVideoList(pv) {
	return request({
		url: '/robot/videoList',
		method: 'post',
		data: {
			...pv
		}
	})
}

export function handleEvent(pv) {
	return request({
		url: '/event/handleEvent',
		method: 'post',
		data: {
			...pv
		}
	})
}

export function getEventType(pv) {
	return request({
		url: '/event/eventType?tenantInfoId=' + pv.replaceAll("\"", ""),
		method: 'get',
	})
}

export function getReportEventTypeByRobotId(pv) {
	return request({
		url: '/event/getReportEventTypeByRobotId?number=' + pv.replaceAll("\"", ""),
		method: 'get',
	})
}

export function addEvent(pv) {
	return request({
		url: '/event/addEvent',
		method: 'post',
		data: {
			...pv
		}
	})
}

export function getVideoListDetail(pv) {
	return request({
		url: '/robot/videoList',
		method: 'post',
		data: {
			...pv
		}
	})
}

export function getRobotEventDetail(pv, tenId) {
	return request({
		url: '/event/robotEventInfo?robotId=' + pv.replaceAll("\"", "") + '&tenantInfoId=' + tenId.replaceAll(
			"\"", ""),
		method: 'get'
	})
}

export function getRobotEventDetailRobot(pv, tenId, eventResult, disshowFlg) {
	return request({
		url: '/event/robotEventInfo?robotId=' + pv.replaceAll("\"", "") + '&tenantInfoId=' + tenId.replaceAll(
			"\"", "") + '&eventResult=' + eventResult.replaceAll("\"", "") + '&disshowFlg=' + disshowFlg.replaceAll("\"", ""),
		method: 'get'
	})
}

export function control(pv) {
	return request({
		url: '/robot/control',
		method: 'post',
		data: {
			...pv
		}
	})
}

export function deControl(pv) {
	return request({
		url: '/robot/deControl',
		method: 'post',
		data: {
			...pv
		}
	})
}

export function robotVideo(pv) {
	return request({
		url: '/robot/robotVideo',
		method: 'post',
		data: {
			...pv
		}
	})
}

export function robotEventList(pv) {
	return request({
		url: '/robot/robotEventList',
		method: 'post',
		data: {
			...pv
		}
	})
}

export function robotVideoList(pv) {
	return request({
		url: '/robot/robotVideoList',
		method: 'post',
		data: {
			...pv
		}
	})
}

export function eventDetail(pv) {
	return request({
		url: '/robot/eventDetail?eventId=' + pv.replaceAll("\"", ""),
		method: 'get'
	})
}

// 租户下所有机器人列表
export function robotByTenantInfoId(tenId) {
	return request({
		url: '/robot/robotByTenantInfoId?tenantInfoId=' + tenId.replaceAll("\"", ""),
		method: 'get'
	})
}

// 租户下事件列表
export function eventTypeByTenantInfoId(tenId) {
	return request({
		url: '/event/eventTypeByTenantInfoId?tenantInfoId=' + tenId.replaceAll("\"", ""),
		method: 'get'
	})
}

// 批量处理事件
export function handleEventBatch(pv) {
	return request({
		url: '/event/handleEventBatch',
		method: 'post',
		data: {
			...pv
		}
	})
}

// 查看温度，湿度
export function getWeather(tenId, num) {
	return request({
		url: '/robot/getWeather?tenantInfoId=' + tenId.replaceAll("\"", "") + '&number=' + num.replaceAll("\"",
			""),
		method: 'get'
	})
}

// 处理并上报
export function handleEventReport(pv) {
	return request({
		url: '/event/handleEventReport',
		method: 'post',
		data: {
			...pv
		}
	})
}

// 获取websorct
export function webRtcToken(pv) {
	return request({
		url: '/robot/webRtcToken',
		method: 'post',
		data: {
			...pv
		}
	})
}

// 通讯
export function switchWebRtc(pv) {
	return request({
		url: '/robot/switchWebRtc',
		method: 'post',
		data: {
			...pv
		}
	})
}

// 通讯记录
export function saveRobotHistory(pv) {
	return request({
		url: '/robot/saveRobotHistory',
		method: 'post',
		data: {
			...pv
		}
	})
}

// 口罩列表
export function maskList(pv) {
	return request({
		url: '/robot/maskList?groupIds=' + pv.replaceAll("\"", ""),
		method: 'get'
	})
}

// 云台方向
export function angleControl(pv) {
	return request({
		url: '/ptz/angleControl',
		method: 'post',
		data: {
			...pv
		}
	})
}

// 升降杆运动
export function rodControl(pv) {
	return request({
		url: '/ptz/rodControl',
		method: 'post',
		data: {
			...pv
		}
	})
}

// 焦距
export function focusesControl(pv) {
	return request({
		url: '/ptz/focusesControl',
		method: 'post',
		data: {
			...pv
		}
	})
}

// 获取焦距
export function getPtz(pv) {
	return request({
		url: '/ptz/getPtz',
		method: 'post',
		data: {
			...pv
		}
	})
}

// 获取标签点
export function getRfid(pv) {
	return request({
		url: '/rfid/list',
		method: 'post',
		data: {
			...pv
		}
	})
}

// 雨刷
export function ptzWiper(pv) {
	return request({
		url: '/ptz/wiper',
		method: 'post',
		data: {
			...pv
		}
	})
}

// 人脸详情
export function completionInfo(pv) {
	return request({
		url: '/face/completionInfo',
		method: 'post',
		data: {
			...pv
		}
	})
}

// 人员类型
export function personType(pv) {
	return request({
		url: '/face/personType',
		method: 'post',
		data: {
			...pv
		}
	})
}

// 证件类型
export function idType(pv) {
	return request({
		url: '/face/idType',
		method: 'post',
		data: {
			...pv
		}
	})
}

// 统计主动呼叫
export function callCount(pv) {
	return request({
		url: '/robot/callCount',
		method: 'post',
		data: {
			...pv
		}
	})
}

// 多语言切换
export function setLanguage(pv) {
	return request({
		url: '/messages/setLanguage?lang=' + pv.replaceAll("\"", ""),
		method: 'get'
	})
}

// 丰台-存机器监控视频
export function showChoose(pv) {
	return request({
		url: '/robot/video/show/choose',
		method: 'post',
		data: {
			...pv
		}
	})
}

// 丰台-机器监控视频列表
export function showListIds(robotIds) {
	return request({
		url: `/robot/video/show/list/${robotIds}`,
		method: 'get'
	})
}

// 查询事件列表- 过滤
export function eventTypeByRobotId(number) {
	return request({
		url: `/event/eventTypeByRobotId?number=${number}`,
		method: 'get'
	})
}

/**
 * 警情处理
 * 0 原地等待
 * 1 继续等待
 * 2 结束原地等待
 * 3 引路报警
 * 4 结束引路报警
 */
export function alarmOperate(pv) {
	return request({
		url: '/ftRobot/alarmOperate',
		method: 'post',
		data: {
			...pv
		}
	})
}

/**
* 丰台语音挂断
*/
export function ftRobotHangUp(pv) {
	return request({
		url: '/ftRobot/hangUp',
		method: 'post',
		data: {
			...pv
		}
	})
}

/**
* 上报误识别说明
*/
export function reportMisIdentification(pv) {
	return request({
		url: '/event/reportMisIdentification',
		method: 'post',
		data: {
			...pv
		}
	})
}

/**
* 一键回充
*/
export function setCharingTask(pv) {
	return request({
		url: '/robot/setCharingTask',
		method: 'post',
		data: {
			...pv
		}
	})
}

/**
 * 访客登记
 */
export function saveVisitor(data) {
	return request({
		url: '/robot/visitor/save',
		method: 'post',
		data,
	})
}

/**
 * 查询罐体列表
 */
export function tankList() {
	return request({
		url: '/chemical/tankList',
		method: 'get',
	})
}

/**
 * 查询可用的机器人列表
 */
export function getRobotList(tenantInfoId) {
	return request({
		url: `/chemical/getRobotList/${tenantInfoId}`,
		method: 'get',
	})
}

/**
 * 下发任务
 */
export function issueTasks(data) {
	return request({
		url: `/chemical/issueTasks`,
		method: 'post',
		data,
	})
}

/**
 * 复查任务详情
 */
export function tankDetails(recordId) {
	return request({
		url: `/chemical/tankDetails/${recordId}`,
		method: 'get',
	})
}

/**
 * 取消任务
 */
export function cancelTask(recordId) {
	return request({
		url: `/chemical/cancelTask/${recordId}`,
		method: 'get',
	})
}
/**
 * 修改急停状态
 */
export function sendButtonStop(data) {
	return request({
		url: `/robot/sendButtonStop`,
		method: 'post',
		data,
	})
}
/**
 * 复查确认
 */
export function confirm(recordId) {
	return request({
		url: `/chemical/confirm/${recordId}`,
		method: 'get',
	})
}

/**
 * 手动更改阀门识别状态
 */
export function changeStatus(detailId) {
	return request({
		url: `/chemical/changeStatus/${detailId}`,
		method: 'get',
	})
}

/**
 * 跑冒滴漏列表
 */
export function getEventTankList(tenantInfoId) {
	return request({
		url: `chemical/getEventTankList/${tenantInfoId}`,
		method: 'get',
	})
}

/**
 * 巡检记录列表
 */
export function getInspectionRecords(data) {
	return request({
		url: `chemical/getInspectionRecords`,
		method: 'post',
		data,
	})
}

// 室内机器人 --- 设置打卡点信息
export function setFloorPositon(data) {
	return request({
		url: `/robot/inDoor/setFloorPositon`,
		method: 'post',
		data,
	})
}

// 室外机器人 --- 设置打卡点信息
export function setPositon(data) {
	return request({
		url: `/robot/third/setPositon`,
		method: 'post',
		data,
	})
}

// 室外机器人 --- 设置路綫点信息
export function setCoord(data) {
	return request({
		url: `/robot/third/setCoord`,
		method: 'post',
		data,
	})
}

export function positonInfo(pv) {
	return request({
		url: '/robot/positonInfo',
		method: 'post',
		data: { ...pv }
	})
}



// WEBPACK FOOTER //
// ./src/api/admin.js